<template>
  <v-layout row justify-center>
    <v-dialog v-model="show" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card class="justify-center" color="black" dark>
        <div class="container-notification">
          <img class="align-center" src="/logo-mikro.png" alt="">
          <v-flex xs10 offset-xs1 sm8 offset-sm2 md6 offset-md3 class="text-xs-center">
            <h2>Microcanales no está disponible para tú país.</h2>
          </v-flex>
          <v-btn color="primary" class="align-center-btn" width="340px"
            @click="redirect">Continuar</v-btn>
        </div>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>

export default {
  data: () => ({
    show: true
  }),
  methods: {
    check () {
      this.show = true
    },
    redirect () {
      return history.go(-1)
    }
  },
  activated () {
    this.check()
  }
}
</script>
<style scoped>
  .align-center {
    margin-top: 10%;
    margin-left: calc(50% - 165px);
  }
  .align-center-btn {
    display: block;
    margin-left: calc(50% - 136px);
  }
  .button-appstore {
    width: 150px;
    margin: auto 10px;
  }
</style>
<style>
  .align-center-btn * {
    width: 240px;
  }
</style>